// Qude i18n — translations for all supported languages
// Add new languages by adding a new key with the same structure as 'en'

export const LANGUAGES = [
  { code: 'en', label: 'English',    flag: '🇺🇸' },
  { code: 'es', label: 'Español',    flag: '🇪🇸' },
  { code: 'fr', label: 'Français',   flag: '🇫🇷' },
  { code: 'pt', label: 'Português',  flag: '🇧🇷' },
  { code: 'ko', label: '한국어',      flag: '🇰🇷' },
];

const translations = {
  en: {
    // Nav
    dashboard:    'Dashboard',
    watchlist:    'Watchlist',
    services:     'Services',
    folders:      'Folders',
    reminders:    'Reminders',
    qmate:        'QMate',
    pricing:      'Pricing',
    settings:     'Settings',
    // Watchlist
    watchlist_title:      'Watchlist',
    shows_tracked:        '{n} shows tracked',
    add_show:             'Add Show',
    search_watchlist:     'Search your watchlist...',
    continue_watching:    'Continue Watching',
    no_shows:             'No shows yet. Add your first show to get started!',
    // Status
    watching:     'Watching',
    watched:      'Finished',
    want_to_watch:'In Queue',
    // Dashboard
    tonights_pick:        "Tonight's Pick",
    pick_tonight:         "Pick tonight's show",
    play_now:             'PLAY NOW',
    not_this:             'Not this? Pick another',
    // Settings
    settings_title:       'Settings',
    appearance:           'Appearance',
    dark_mode:            'Dark Mode',
    text_size:            'Text Size',
    accessibility:        'Accessibility',
    colorblind_mode:      'Colorblind Mode',
    reduce_motion:        'Reduce Motion',
    rtl_layout:           'Right-to-Left Layout',
    language:             'Language',
    account:              'Account',
    export_data:          'Export My Data',
    delete_account:       'Delete Account',
    delete_confirm:       'Are you sure? This permanently deletes all your data.',
    notifications:        'Notifications',
    // Common
    save:     'Save',
    cancel:   'Cancel',
    done:     'Done',
    loading:  'Loading...',
    error:    'Something went wrong',
    upgrade:  'Upgrade',
  },

  es: {
    dashboard:    'Inicio',
    watchlist:    'Mi Lista',
    services:     'Servicios',
    folders:      'Carpetas',
    reminders:    'Recordatorios',
    qmate:        'QMate',
    pricing:      'Precios',
    settings:     'Ajustes',
    watchlist_title:      'Mi Lista',
    shows_tracked:        '{n} series seguidas',
    add_show:             'Añadir Serie',
    search_watchlist:     'Buscar en mi lista...',
    continue_watching:    'Continuar Viendo',
    no_shows:             '¡Aún no tienes series. Añade tu primera!',
    watching:     'Viendo',
    watched:      'Vista',
    want_to_watch:'En Cola',
    tonights_pick:        'Para Esta Noche',
    pick_tonight:         '¿Qué veo esta noche?',
    play_now:             'VER AHORA',
    not_this:             '¿Otra? Cambiar',
    settings_title:       'Ajustes',
    appearance:           'Apariencia',
    dark_mode:            'Modo Oscuro',
    text_size:            'Tamaño de Texto',
    accessibility:        'Accesibilidad',
    colorblind_mode:      'Modo Daltónico',
    reduce_motion:        'Reducir Movimiento',
    rtl_layout:           'Diseño de Derecha a Izquierda',
    language:             'Idioma',
    account:              'Cuenta',
    export_data:          'Exportar Mis Datos',
    delete_account:       'Eliminar Cuenta',
    delete_confirm:       '¿Seguro? Esto elimina todos tus datos permanentemente.',
    notifications:        'Notificaciones',
    save:     'Guardar',
    cancel:   'Cancelar',
    done:     'Listo',
    loading:  'Cargando...',
    error:    'Algo salió mal',
    upgrade:  'Mejorar',
  },

  fr: {
    dashboard:    'Accueil',
    watchlist:    'Ma Liste',
    services:     'Services',
    folders:      'Dossiers',
    reminders:    'Rappels',
    qmate:        'QMate',
    pricing:      'Tarifs',
    settings:     'Paramètres',
    watchlist_title:      'Ma Liste',
    shows_tracked:        '{n} séries suivies',
    add_show:             'Ajouter une série',
    search_watchlist:     'Rechercher dans ma liste...',
    continue_watching:    'Continuer à regarder',
    no_shows:             "Pas encore de séries. Ajoutez votre première !",
    watching:     'En cours',
    watched:      'Terminée',
    want_to_watch:'À voir',
    tonights_pick:        'Pour ce soir',
    pick_tonight:         'Que regarder ce soir ?',
    play_now:             'REGARDER',
    not_this:             'Autre chose ?',
    settings_title:       'Paramètres',
    appearance:           'Apparence',
    dark_mode:            'Mode sombre',
    text_size:            'Taille du texte',
    accessibility:        'Accessibilité',
    colorblind_mode:      'Mode daltonien',
    reduce_motion:        'Réduire les animations',
    rtl_layout:           'Disposition droite-à-gauche',
    language:             'Langue',
    account:              'Compte',
    export_data:          'Exporter mes données',
    delete_account:       'Supprimer le compte',
    delete_confirm:       'Vous êtes sûr ? Cela supprime définitivement toutes vos données.',
    notifications:        'Notifications',
    save:     'Enregistrer',
    cancel:   'Annuler',
    done:     'Terminé',
    loading:  'Chargement...',
    error:    "Quelque chose s'est mal passé",
    upgrade:  'Améliorer',
  },

  pt: {
    dashboard:    'Início',
    watchlist:    'Minha Lista',
    services:     'Serviços',
    folders:      'Pastas',
    reminders:    'Lembretes',
    qmate:        'QMate',
    pricing:      'Planos',
    settings:     'Configurações',
    watchlist_title:      'Minha Lista',
    shows_tracked:        '{n} séries salvas',
    add_show:             'Adicionar Série',
    search_watchlist:     'Buscar na minha lista...',
    continue_watching:    'Continuar Assistindo',
    no_shows:             'Nenhuma série ainda. Adicione a primeira!',
    watching:     'Assistindo',
    watched:      'Assistido',
    want_to_watch:'Na Fila',
    tonights_pick:        'Para Esta Noite',
    pick_tonight:         'O que assistir hoje?',
    play_now:             'ASSISTIR AGORA',
    not_this:             'Outra sugestão',
    settings_title:       'Configurações',
    appearance:           'Aparência',
    dark_mode:            'Modo Escuro',
    text_size:            'Tamanho do Texto',
    accessibility:        'Acessibilidade',
    colorblind_mode:      'Modo Daltônico',
    reduce_motion:        'Reduzir Animações',
    rtl_layout:           'Layout da Direita para Esquerda',
    language:             'Idioma',
    account:              'Conta',
    export_data:          'Exportar Meus Dados',
    delete_account:       'Excluir Conta',
    delete_confirm:       'Tem certeza? Isso exclui permanentemente todos os seus dados.',
    notifications:        'Notificações',
    save:     'Salvar',
    cancel:   'Cancelar',
    done:     'Pronto',
    loading:  'Carregando...',
    error:    'Algo deu errado',
    upgrade:  'Atualizar',
  },

  ko: {
    dashboard:    '홈',
    watchlist:    '내 목록',
    services:     '서비스',
    folders:      '폴더',
    reminders:    '알림',
    qmate:        'QMate',
    pricing:      '요금제',
    settings:     '설정',
    watchlist_title:      '내 목록',
    shows_tracked:        '{n}개 프로그램',
    add_show:             '프로그램 추가',
    search_watchlist:     '목록 검색...',
    continue_watching:    '이어보기',
    no_shows:             '아직 프로그램이 없습니다. 첫 번째를 추가해보세요!',
    watching:     '시청 중',
    watched:      '완료',
    want_to_watch:'대기 중',
    tonights_pick:        '오늘의 추천',
    pick_tonight:         '오늘 뭐 볼까요?',
    play_now:             '지금 시청',
    not_this:             '다른 추천',
    settings_title:       '설정',
    appearance:           '외관',
    dark_mode:            '다크 모드',
    text_size:            '글자 크기',
    accessibility:        '접근성',
    colorblind_mode:      '색맹 모드',
    reduce_motion:        '움직임 줄이기',
    rtl_layout:           '오른쪽에서 왼쪽으로',
    language:             '언어',
    account:              '계정',
    export_data:          '내 데이터 내보내기',
    delete_account:       '계정 삭제',
    delete_confirm:       '정말요? 모든 데이터가 영구적으로 삭제됩니다.',
    notifications:        '알림',
    save:     '저장',
    cancel:   '취소',
    done:     '완료',
    loading:  '불러오는 중...',
    error:    '오류가 발생했습니다',
    upgrade:  '업그레이드',
  },
};

export function t(key, lang = 'en', vars = {}) {
  const dict = translations[lang] || translations.en;
  let str = dict[key] || translations.en[key] || key;
  // Replace {n}, {name} etc
  Object.entries(vars).forEach(([k, v]) => {
    str = str.replace(`{${k}}`, v);
  });
  return str;
}

export default translations;
